import { render, staticRenderFns } from "./IssueBadgeButton.vue?vue&type=template&id=9f672a12&scoped=true"
import script from "./IssueBadgeButton.vue?vue&type=script&setup=true&lang=js"
export * from "./IssueBadgeButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IssueBadgeButton.vue?vue&type=style&index=0&id=9f672a12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f672a12",
  null
  
)

export default component.exports